import Vue from 'vue';
import store from './App/Store';
import axios from "axios";

Vue.config.productionTip = false;

window.Vue = Vue;

/********************************************************************
 * VUETIFY
 ********************************************************************/

import Vuetify from 'vuetify';

Vue.use(Vuetify);

let vuetify = new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        themes: {
            light: {
                primary: '#273149',
                success: '#0dc378',
                info: '#5D87C0',
                warning: '#fd7800',
            },
            dark: {
                primary: '#273149',
                success: '#0dc378',
                info: '#5D87C0',
                warning: '#fd7800',
            },
        }
    },
});

/********************************************************************
 * ROUTER
 ********************************************************************/

import VueRouter from 'vue-router';
import router from './router';

Vue.use(VueRouter);
Vue.router = router;

/********************************************************************
 * APP
 ********************************************************************/

require('./App/index');

import {mapActions, mapGetters} from "vuex";

import Index from "./Components/Index";
import AppSnackBar from "./Components/Base/AppSnackBar";

Vue.component('index', Index);
Vue.component('app-snack-bar', AppSnackBar);

store
    .subscribe((mutation) => {
        switch (mutation.type) {
            case 'auth/SET_TOKEN':
                if (mutation.payload) {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`;

                    localStorage.setItem('token', mutation.payload);
                } else {
                    axios.defaults.headers.common['Authorization'] = null;

                    localStorage.removeItem('token');
                }
                break;
        }
    })

store
    .dispatch('auth/attempt', localStorage.getItem('token'))
    .catch(error => {
        Vue.router.push('/login')
    })
    .then(() => {
        const app = new Vue({
            el: '#app',
            store,
            vuetify,
            router,
            data() {
                return {};
            },

            computed: {
                ...mapGetters({
                    user: 'auth/user'
                })
            },

            methods: {
                ...mapActions({
                    logoutAction: 'auth/logout'
                }),
            }
        });
    });
